// This file contains definitions for the JdaValidate object.
// This object contains things that are complementary to, and thin wrappers around
// the ValidateJS (ansman/validate.js) form validation vendor plugin.
// ValidateJS is quite a nice validation plugin in that it provides validation functionality
// without forcing any kind of event structure or bindings. This means we can handle when and how we process our
// validation as we please, and more easily integrate it with any other plugins or patterns we are already using.

// Most properties of the JdaValidate object are helper functions. It may help to think of these as static functions.
// The main exception to this is the this function property, which deserves a special mention.
// This is a constructor function, which creates a customisable validation wrapper object, that helps with
// manipulating the DOM, appending error messages etc. For more information, read the comments that appear just above that.

// There is a dependancy on the JDAUpload jQuery plugin for file validations.

app.registerLib('validator', function (app) {

    var helpers = app.helpers.funcs;
    var debug = false;

    var debugMessage = function () {
        if (debug) console.log(arguments);
    };

    function ValidationManager(components, $formElem) {

        var scope = this;

        // Specify the form element to be validated
        this.$formElem = $formElem;

        // A files cache
        this.cachedValues = null;

        // Create instances of the 'fixed' validation components
        // The constructors for these only need to be called here.
        this.configuration = helpers.arrayGet(components, 'configuration', new Configuration(this));
        this.constraintBag = helpers.arrayGet(components, 'constraintBag', new ConstraintBag(this));
        this.templater = helpers.arrayGet(components, 'templater', new Templater(this));
        this.presenter = helpers.arrayGet(components, 'presenter', new Presenter(this));
        this.validator = helpers.arrayGet(components, 'validator', new Validator(this));

        // Specify which constructos we will be using for transient components
        // These components may be created or destroyed through the lifecycle of this instance of a validation manager.
        this.MessageBag = helpers.arrayGet(components, 'MessageBag', MessageBag);
        this.Message = helpers.arrayGet(components, 'Message', Message);
        this.Constraint = helpers.arrayGet(components, 'Constraint', Constraint);

        // Helper functions
        this.getMessageBag = function () {
            var messageBag = new scope.MessageBag(scope);
            messageBag.setMessagesFromForm();
            return messageBag;
        }
        this.getMessageBagForFormField = function (formFieldId, $formField) {
            var messageBag = scope.getMessageBag();
            return messageBag.newFilterdBagForFormField(formFieldId, $formField);
        }

        // Cached values managment. In some cases its not possible to obtain the value of file inputs
        // with the usual methods. In such cases, we can get around this problem by passing in the files
        // to be cached within the validationManager object, and then reference these when testing
        // the values against our constraints.
        this.cacheValuesForFormField = function(formFieldId, values) {
            scope.cachedValues = scope.cachedValues === null ? {} : scope.cachedValues;
            scope.cachedValues[formFieldId] = values;
        }
        this.clearCachedValuesForFormField = function(formFieldId) {
            if (scope.cachedValues) {
                delete scope.cachedValues[formFieldId];
            }
        }
        this.clearCachedFiles = function () {
            scope.cachedValues = null;
        }
        this.getCachedValue = function (formFieldId) {
            if (!scope.cachedValues) return null;
            return typeof scope.cachedValues[formFieldId] !== 'undefined' ? scope.cachedValues[formFieldId] : null;
        }
    };

    function Configuration(validationManager) {
        var scope = this;
        this.validationManager = validationManager;
        if (typeof Configuration._initd === 'undefined') {
                
            Configuration.prototype.emailPattern = /^([A-Za-z0-9_\-\.\+\'])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,62})$/;
            Configuration.prototype.datePattern = /(0?[1-9]|[12][0-9]|3[01])[- /.](0?[1-9]|1[012])[- /.](19|20)\d\d/;
            Configuration.prototype.urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
            Configuration.prototype.strongPasswordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[:;'_=#?!@$%^&~<>*-./\"()\\\\])/;
                
            Configuration.prototype.messages = {};
            Configuration.prototype.messages.successMessage = function () {
                return 'Looks good';
            };
            Configuration.prototype.messages.regularExpression = function (constraint) {
                return 'This is in an invalid format';
            };
            Configuration.prototype.messages.email = function (constraint) {
                return 'This email is invalid';
            };
            Configuration.prototype.messages.url = function (constraint) {
                return 'This url is invalid';
            };
            Configuration.prototype.messages.date = function (constraint) {
                return 'This date is invalid';
            };
            Configuration.prototype.messages.strongPassword = function (constraint) {
                return 'Your password must be stronger';
            };
            Configuration.prototype.messages.present = function (constraint) {
                return 'This field must be supplied';
            };
            Configuration.prototype.messages.inArray = function (constraint) {
                return 'This value is not allowed';
            };
            Configuration.prototype.messages.notInArray = function (constraint) {
                return 'This value is not allowed';
            };
            Configuration.prototype.messages.numeric = function (constraint) {
                return 'This value must be numeric';
            };
            Configuration.prototype.messages.onlyDigits = function (constraint) {
                return 'This value can only consist of digits';
            };
            Configuration.prototype.messages.minLength = function (constraint) {
                return 'This is too short';
            };
            Configuration.prototype.messages.maxLength = function (constraint) {
                return 'This is too long';
            };
            Configuration.prototype.messages.minItems = function (constraint) {
                return 'You must select more items.';
            };
            Configuration.prototype.messages.maxItems = function (constraint) {
                return 'You must select less items.';
            };
            Configuration.prototype.messages.minNumber = function (constraint) {
                return 'This number is too small';
            };
            Configuration.prototype.messages.maxNumber = function (constraint) {
                return 'This number is too large';
            };
            Configuration.prototype.messages.confirmed = function (constraint) {
                return 'This field does not match';
            };
            Configuration.prototype.messages.minFileSize = function (constraint) {
                return 'This file is too small';
            };
            Configuration.prototype.messages.maxFileSize = function (constraint) {
                return 'This file is too large';
            };
            Configuration.prototype.messages.fileType = function (constraint) {
                return 'This is file format is not supported';
            };

            // Returns true if the key being released is in list of ignored keys
            Configuration.prototype.keyUpShouldBeIgnored = function (e) {
                var ignoreKeys = [
                    17, // CTRL
                    18, // ALT / ALTGR
                    16, // SHIFT
                    9, // TAB
                    27, // ESC
                    93, // OPENDIALOG
                    19, // BREAK
                    33, // PGUP
                    34, // PGDOWN
                    36, // HOME
                    35, // END
                    38, // UP
                    40, // DOWN
                    37, // LEFT
                    39, // RIGHT
                    20, // CAPSLOCK
                    144, // NUMLOCK
                    145, // SCROLLLOCK
                    112, // F1
                    113, // F2
                    114, // F3
                    115, // F4
                    116, // F5
                    117, // F6
                    118, // F7
                    119, // F8
                    120, // F9
                    121, // F10
                    122, // F11
                    123, // F12
                ];
                return $.inArray(e.which, ignoreKeys) > -1;
            };

            // If this returns true, it indicates that the form field specified ($fomField)
            // should be excluded from the validation process.
            // This default returns true if the element has a data-ignored attribute, a name of ufprt, or is invisible.
            Configuration.prototype.formFieldShouldBeIgnored = function ($formField) {

                // If the element has a data-ignored attribute, or its name is ufprt (a google validate input),
                // it should be excluded from validation.
                if ($formField.data('ignored') || $formField.attr('name') == 'ufprt') {
                    return true;
                }

                // If we can't work out a form field id, $formField should be excluded from validation.
                var formFieldId = this.validationManager.configuration.getFormFieldId($formField);
                if (!formFieldId) return true;

            };

            Configuration.prototype.getFormField = function (formFieldId) {
                var $byData = this.validationManager.$formElem.find('*[data-validation-name=' + formFieldId + ']');
                if ($byData.length) return $byData;
                return this.validationManager.$formElem.find('#' + formFieldId);
            };

            Configuration.prototype.getFormFieldId = function ($formField) {
                var dataId = $formField.data('validation-name');
                if (dataId) return dataId;
                return $formField.attr('id');
            };

            Configuration.prototype.getFormFieldType = function ($formField) {
                var elemType = $formField.get(0).tagName.toLowerCase();
                if (elemType == 'textarea' || elemType == 'select') return elemType;
                return $formField.attr('type');
            };

            Configuration.prototype.isCollectionOfRepeatingFields = function ($formField) {
                var type = this.validationManager.configuration.getFormFieldType($formField);
                return (type !== 'checkbox' && type !== 'radio' && $formField.length > 1);
            };

            Configuration.prototype.getFormFieldValue = function ($formField) {

                if ($formField.length > 1) {
                    var type = this.validationManager.configuration.getFormFieldType($($formField.get(0)));
                    if (type == 'checkbox' || type == 'radio') {
                        $formField = $formField.filter(':checked');
                    }
                    var selected = [];
                    $formField.each(function (k, v) {
                        var val = $(v).val();
                        selected.push(val);
                    });
                    return selected;
                } else {
                    var formFieldId = validationManager.configuration.getFormFieldId($formField);
                    var cachedValue = validationManager.getCachedValue(formFieldId);
                    return cachedValue !== null ? cachedValue : $formField.val();
                }
            };

            Configuration.prototype.getFiles = function ($formField) {
                if ($.fn.jdaUpload) {
                    var jdaUpload = $formField.jdaUpload(true);
                    if (jdaUpload) {
                        return jdaUpload.getFiles();
                    }
                }
                var uicFiles = $formField.data('uploadImagesCaptionsFiles');
                if (uicFiles) {
                    return uicFiles;
                }
            };

            Configuration.prototype.getSizeOfFiles = function (files) {
                var total = 0;
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    total += file.size;
                }
                return total;
            };

            Configuration._initd = true;
        }
    };

    function ConstraintBag(validationManager) {

        var scope = this;
        this.validationManager = validationManager;
        this.constraints = [];

        if (typeof ConstraintBag._initd === 'undefined') {

            ConstraintBag.prototype.addConstraints = function (constraintsList, resetConstraints) {
                resetConstraints = typeof resetConstraints !== 'undefined' ? resetConstraints : false;
                var functionScope = this;
                if (resetConstraints) {
                    functionScope.removeAllConstraints();
                }
                Object.keys(constraintsList).forEach(function (constraintsKey) {
                    var formConstraints = constraintsList[constraintsKey];
                    var theConstraints;
                    var formFieldId;
                    if (formConstraints instanceof Array) {
                        if (formConstraints[0] instanceof String || typeof formConstraints[0] === 'string') {
                            theConstraints = formConstraints[1];
                            formFieldId = formConstraints[0];
                        } else {
                            theConstraints = formConstraints;
                            formFieldId = constraintsKey;
                        }
                        theConstraints.forEach(function (constraintLiteral) {
                            var constraintObject = new functionScope.validationManager.Constraint(
                                functionScope.validationManager,
                                formFieldId,
                                constraintLiteral.type,
                                constraintLiteral.params,
                                constraintLiteral.errorCode,
                                constraintLiteral.severity
                            );
                            functionScope.addConstraint(constraintObject);
                        });
                    }
                });
            };

            ConstraintBag.prototype.addConstraint = function (constraint) {
                var formFieldId = constraint.getFormFieldId();
                var constraintType = constraint.getType();
                if (!this.hasConstraint(formFieldId, constraintType)) {
                    debugMessage('%c Adding constraint: ' + formFieldId + ' ' + constraintType, 'color: #00ff00');
                    this.constraints.push(constraint);
                } else {
                    debugMessage('%c Not adding constraint: ' + formFieldId + '-' + constraintType, 'background: #000');
                }
            };

            ConstraintBag.prototype.removeConstraint = function (formFieldId, constraintType) {
                if (!(formFieldId && constraintType)) {
                    debugMessage('Error: Both form field id and constraint type must be supplied.');
                    return;
                }
                var newConstraints = [];
                this.constraints.forEach(function (constraint) {
                    var r = ((constraint.getFormFieldId() == formFieldId) && (constraint.getType() == constraintType));
                    if (r) {
                        debugMessage('%c Removing constraint: ' + constraint.getFormFieldId() + ' ' + constraint.getType(), 'color: #ff0000');
                    } else {
                        newConstraints.push(constraint);
                    }
                });
                this.constraints = newConstraints;
                return newConstraints;
            };

            ConstraintBag.prototype.setConstraintSeverity = function (formFieldId, constraintType, severity) {
                if (!(formFieldId && constraintType)) {
                    debugMessage('Error: Both form field id and constraint type must be supplied.');
                    return;
                }
                this.constraints.forEach(function (constraint) {
                    var r = ((constraint.getFormFieldId() == formFieldId) && (constraint.getType() == constraintType));
                    if (r) {
                        constraint.setSeverity(severity);
                    }
                });
            };

            ConstraintBag.prototype.hasConstraint = function (formFieldId, constraintType) {
                var r = this.constraints.some(function (constraint) {
                    return ((constraint.getFormFieldId() == formFieldId) && (constraint.getType() == constraintType));
                });
                return r;
            }
            
            ConstraintBag.prototype.removeAllConstraints = function () {
                debugMessage('%c Removed all constraints', 'background: #ff0000');
                this.constraints = [];
            };

            ConstraintBag.prototype.getConstraint = function (formFieldId, constraintType) {
                var foundConstraint = null;
                this.constraints.forEach(function (constraint) {
                    if ((constraint.getFormFieldId() == formFieldId) && (constraint.getType() == constraintType)) {
                        foundConstraint = constraint;
                    }
                });
                return foundConstraint;
            };

            ConstraintBag.prototype.getConstraintsForField = function (formFieldId) {
                return this.constraints.filter(function (constraint) {
                    return constraint.getFormFieldId() == formFieldId;
                });
            };

            ConstraintBag._initd = true;
        }
    };

    function Constraint(validationManager, formFieldId, constraintType, constraintParams, errorCode, severity) {
        var scope = this;
        this.validationManager = validationManager;
        this.formFieldId = formFieldId;
        this.type = constraintType;
        this.params = constraintParams;
        this.errorCode = errorCode;
        this.severity = ($.inArray(severity, ['error', 'warning', 'ignored']) > -1) ? severity : 'error';
        this.getLocalErrorMessage = null; // Can be populated with a function for a customised message, specific to this particular constraint.
        if (typeof Constraint._initd === 'undefined') {
            Constraint.prototype.getType = function () {
                return this.type;
            };
            Constraint.prototype.getErrorCode = function () {
                return this.errorCode;
            };
            Constraint.prototype.getParams = function () {
                var functionScope = this;
                var o = {};
                Object.keys(this.params).forEach(function (paramK) {
                    var param = functionScope.params[paramK];
                    val = param;
                    if (typeof param == 'function') {
                        var constraint = functionScope;
                        val = param({
                            constraint: constraint
                        });
                    }
                    o[paramK] = val;
                });
                return o;
            };
            Constraint.prototype.getFormFieldId = function () {
                return this.formFieldId;
            };
            Constraint.prototype.getFormField = function () {
                return this.validationManager.configuration.getFormField(this.formFieldId);
            };
            Constraint.prototype.getConstraintType = function () {
                return this.type;
            };
            Constraint.prototype.getSeverity = function () {
                return this.severity;
            };
            Constraint.prototype.getFormFieldType = function () {
                var $formField = this.getFormField();
                return this.validationManager.configuration.getFormFieldType($formField);
            };
            Constraint.prototype.test = function ($formField) {
                var functionScope = this;
                var methodName = 'test' + helpers.ucFirst(this.type);
                $formField = typeof $formField !== 'undefined' ? $formField : this.validationManager.configuration.getFormField(this.formFieldId);
                var formFieldValue = this.validationManager.configuration.getFormFieldValue($formField);
                if (typeof this.validationManager.validator[methodName] !== 'function') {
                    throw '"' + this.type + '" is not a valid validation rule.';
                }
                debugMessage('validator.js: testing rule "' + methodName + '" on field "' + this.formFieldId + '"');
                
                if ($.isArray(formFieldValue)) {
                    if ($.inArray(this.type, ['minItems', 'maxItems']) > -1) {
                        var formFieldId = functionScope.validationManager.configuration.getFormFieldId($formField);
                        var $formFields = functionScope.validationManager.configuration.getFormField(formFieldId);
                        var formFieldValue = functionScope.validationManager.configuration.getFormFieldValue($formFields);
                        return functionScope.validationManager.validator[methodName](formFieldValue, functionScope);
                    } else {
                        var r = formFieldValue.every(function (singleValue) {
                            return functionScope.validationManager.validator[methodName](singleValue, functionScope);
                        });
                        return r;
                    }
                } else {
                    if ($.inArray(this.type, ['minItems', 'maxItems']) > -1) {
                        var formFieldId = functionScope.validationManager.configuration.getFormFieldId($formField);
                        var $formFields = functionScope.validationManager.configuration.getFormField(formFieldId);
                        var formFieldValue = functionScope.validationManager.configuration.getFormFieldValue($formFields);
                        return functionScope.validationManager.validator[methodName](formFieldValue, functionScope);
                    } else {
                        return functionScope.validationManager.validator[methodName](formFieldValue, functionScope);
                    }
                }
            };
            Constraint.prototype.getMessageString = function () {
                if (typeof this.getLocalErrorMessage == 'function') {
                    return this.getLocalErrorMessage(this);
                } else if (typeof this.getLocalErrorMessage == 'string') {
                    return this.getLocalErrorMessage;
                }
                var defaultMessageFunction = this.validationManager.configuration.messages[this.type];
                return (typeof defaultMessageFunction == 'function') ? defaultMessageFunction(this) : 'This field is not valid - "' + this.type + '"';
            };
            Constraint.prototype.setMessageString = function (errorMessageFunction) {
                this.getLocalErrorMessage = errorMessageFunction;
            };
            Constraint.prototype.setSeverity = function (severity) {
                this.severity = ($.inArray(severity, ['error', 'warning', 'ignored']) > -1) ? severity : 'error';
            };
            Constraint._initd = true;
        }
    };

    function MessageBag(validationManager, messages) {
        var scope = this;
        this.validationManager = validationManager;
        this.messages = typeof messages !== 'undefined' ? messages : [];
        if (typeof MessageBag._initd === 'undefined') {

            MessageBag.prototype.setMessagesFromForm = function () {
                var functionScope = this;
                clearBeforeGetting = typeof clearBeforeGetting !== 'undefined' ? clearBeforeGetting : true;
                if (clearBeforeGetting) scope.clearMessages();
                this.validationManager.$formElem.find('input, textarea, select').each(function (k, formField) {
                    var $formField = $(formField);
                    if (!functionScope.validationManager.configuration.formFieldShouldBeIgnored($formField)) {
                        var formFieldId = functionScope.validationManager.configuration.getFormFieldId($formField);
                        functionScope.setMessagesFromField($formField);
                    }
                });
                return this;
            };

            MessageBag.prototype.setMessagesFromField = function ($formField) {

                var functionScope = this;
                if (this.validationManager.configuration.formFieldShouldBeIgnored($formField)) return;
                var formFieldId = this.validationManager.configuration.getFormFieldId($formField);
                this.validationManager.constraintBag.getConstraintsForField(formFieldId).forEach(function (constraint) {
                    var valid = constraint.test($formField);
                    if (!valid) {
                        var messageType = constraint.getType();
                        var message = new functionScope.validationManager.Message(functionScope.validationManager, constraint, $formField);
                        functionScope.addMessage(message);
                    }
                });
            };

            // Returns true if any constraints have failed.
            MessageBag.prototype.hasMessages = function () {
                return !!this.messages.length;
            };

            // Returns true if any constraints that have a severity level of 'error' have failed.
            MessageBag.prototype.hasErrorMessages = function () {
                var filteredMessages = this.messages.filter(function (message) {
                    return message.constraint.getSeverity() == 'error';
                });
                return !!filteredMessages.length;
            };

            // Returns true if any constraints that are tied to the supplied form field(s) have failed 
            MessageBag.prototype.hasMessagesForFormField = function (formFieldId) {
                var formFieldIds = $.isArray(formFieldId) ? formFieldId : [formFieldId];
                var filteredMessages = this.messages.filter(function (message) {
                    return ((message.constraint.getSeverity() == 'error') && ($.inArray(message.getFormFieldId(), formFieldIds) > -1));
                });
                return !!filteredMessages.length;
            };

            MessageBag.prototype.addMessage = function (message) {
                this.messages.push(message);
            };
            MessageBag.prototype.clearMessages = function () {
                this.messages = [];
            };
            MessageBag.prototype.getMessages = function () {
                return this.messages;
            };
            MessageBag.prototype.getFirstMessage = function () {
                if (!this.messages.length) throw 'Could not get first message, as the messages array is empty.';
                return this.messages[0];
            };
            MessageBag.prototype.newFilterdBagForFormField = function (formFieldId, $formFieldElem) {
                $formFieldElem = typeof $formFieldElem !== 'undefined' ? $formFieldElem : false;
                if (!this.hasMessages()) return this;
                var filteredMessages = this.messages.filter(function (message) {
                    return (
                        message.getFormFieldId() == formFieldId // Form field ID match
                        &&
                        ($formFieldElem === false || $formFieldElem.get(0) == message.getFormField().get(0)) // Form field DOM elems match if supplied
                        &&
                        message.constraint.getSeverity() != 'ignored' // Form field severity doesn't indicate that this constraint should be ignored
                    );
                });
                return new this.validationManager.MessageBag(validationManager, filteredMessages);
            };
            MessageBag._initd = true;
        }
    };

    function Message(validationManager, constraint, $formFieldElem) {

        var scope = this;
        this.validationManager = validationManager;
        this.constraint = constraint;
        this.$formFieldElem = $formFieldElem;

        if (typeof Message._initd === 'undefined') {

            // Just a handy alias method
            Message.prototype.getMessageString = function () {
                return this.constraint.getMessageString();
            };

            // Just a handy alias method
            Message.prototype.getFormFieldId = function () {
                return this.constraint.getFormFieldId();
            };

            // Just a handy alias method
            Message.prototype.getErrorCode = function () {
                return this.constraint.getErrorCode();
            };

            Message.prototype.getFormField = function () {
                return this.$formFieldElem;
            };

            Message._initd = true;
        }
    };

    function Templater(validationManager, $formElem) {
        var scope = this;
        this.validationManager = validationManager;
        if (typeof Templater._initd === 'undefined') {
            // Helper generates a markup snippet for showing validation messages as per the design spec.
            Templater.prototype.contextMessage = function (message, variant, useAlert) {
                useAlert = typeof useAlert !== 'undefined' ? useAlert : false;
                var messageString;
                if (message instanceof Message) {
                    messageString = message.getMessageString();
                } else {
                    messageString = message;
                }
                var icons = {
                    danger: 'alert',
                    warning: 'alert',
                    success: 'tick',
                    info: 'tick'
                };
                var iconClass = icons[variant];
                return [
                    '<p class="context-message context-message-' + variant + '"' + (useAlert ? ' role="alert">' : '>'),
                    '<span class="glyph glyph-circle-' + iconClass + '" aria-hidden="true"></span>',
                    '<span class="message">' + messageString + '</span>',
                    '</p>'
                ].join('');
            };
            Templater._initd = true;
        }
    };

    function Presenter(validationManager) {
        var scope = this;
        this.validationManager = validationManager;
        if (typeof Presenter._initd === 'undefined') {

            Presenter.prototype.getFirstBadElem = function () {
                var functionScope = this;

                var $badInputElems = this.validationManager.$formElem.find('.feedback-group-danger input, .feedback-group-danger textarea, .feedback-group-danger select');
                $badInputElems = $badInputElems.filter(function (k, elem) {
                    var $elem = $(elem);
                    return !functionScope.validationManager.configuration.formFieldShouldBeIgnored($elem);
                });
                if (!$badInputElems.length) {
                    $badInputElems = this.validationManager.$formElem.find('.context-message-danger');
                };
                var $firstBadElem = $($badInputElems.get(0));
                return $firstBadElem;
            };
                
            // If there are any errors on the form, scrolls to the first error
            Presenter.prototype.scrollToFirstError = function (cb) {

                var scrollPadding = 110;
                var $firstBadElem = this.validationManager.presenter.getFirstBadElem();
                if (!$firstBadElem.length) {
                    if (typeof cb === 'function') cb(null);
                    return;
                }

                // If the form element is not visible, scroll to the label instead.
                if (!$firstBadElem.is(':visible')) {
                    $firstBadElem = this.validationManager.presenter.getStatusWrapElem($firstBadElem);
                    scrollPadding += 30;
                }

                var $messageElem = this.validationManager.presenter.getStatusWrapElem($firstBadElem);
                var message = $messageElem.text();
                var topOffset = $firstBadElem.offset().top - scrollPadding;
                $messageElem.attr('role', 'alert');

                $('body,html').stop().animate({
                    scrollTop: topOffset
                }, function () {
                    $firstBadElem.focus();
                    if (typeof cb === 'function') cb($firstBadElem);
                });
            };

            // Removes contextual validation classes from group wrappers
            Presenter.prototype.clearGroupWrapContextualClass = function ($elem) {
                $elem
                    .removeClass('feedback-group-danger')
                    .removeClass('feedback-group-warning')
                    .removeClass('feedback-group-info')
                    .removeClass('feedback-group-success')
                ;
            };

            // Removes contextual validation classes from group wrappers, and adds the new class
            Presenter.prototype.changeGroupWrapClassTo = function ($elem, classSfx) {
                this.clearGroupWrapContextualClass($elem);
                $elem.addClass('feedback-group-' + classSfx);
                $elem.focus();
            };


            // Accepts a jquery DOM element ($elem), and deduces the overarching wrap element,
            // which contains both the form input and the validation message area.
            Presenter.prototype.getGroupWrapElem = function ($elem) {
                return $elem.closest('.feedback-group');
            };

            // Accepts a jquery DOM element ($elem), and deduces the companion
            // validation message wrap element, the element that validation messages
            // are placed within.
            Presenter.prototype.getStatusWrapElem = function ($elem) {
                var statusWrapSelector = $elem.data('error-target');
                if (statusWrapSelector) {
                    return $(statusWrapSelector);
                } else {
                    return $elem.closest('.feedback-group').find('.context-message-wrap');
                }
            };

            // Cycles through all form controls that are within the form (specified during the call to the constructor),
            // and calls the showStatus() method on each.
            Presenter.prototype.showStatuses = function (messageBag) {
                var functionScope = this;
                if (typeof messageBag == 'undefined') {
                    messageBag = new this.validationManager.MessageBag();
                    messageBag.setMessagesFromForm();
                }
                this.validationManager.$formElem.find('input, textarea, select').each(function (k, elem) {
                    var $elem = $(elem);
                    functionScope.showStatus($elem, messageBag, true);
                });
            };

            // Updates the displayed validation messages for a single form control. If it is valid,
            // a valid message is added and a valid class is appended to the wrapping elements.
            // If not, an error message is added, and an invalid class is appended.
            // Note that the errors argument should contain all errors for the whole form. If there are any,
            // the ingrained call to showSummaryStatus(error) will add, or remove if not.
            Presenter.prototype.showStatus = function ($formField, messageBag, runningShowStatuses) {

                runningShowStatuses = typeof runningShowStatuses !== 'undefined' ? runningShowStatuses : false;

                var errorCode = false;
                if (this.validationManager.configuration.formFieldShouldBeIgnored($formField)) return;
                var formFieldId = this.validationManager.configuration.getFormFieldId($formField);

                if (typeof messageBag == 'undefined') {
                    messageBag = new this.validationManager.MessageBag();
                    messageBag.setMessagesFromForm();
                }
                messageBag = messageBag.newFilterdBagForFormField(formFieldId, $formField);

                var $groupWrapElem = this.getGroupWrapElem($formField);
                var $statusWrapElem = this.getStatusWrapElem($formField);
                if (messageBag.hasMessages()) {
                    var message = messageBag.getFirstMessage();
                    var severity = message.constraint.getSeverity();
                    var severityClass = severity == 'error' ? 'danger' : 'warning';
                    var statusHtml = this.validationManager.templater.contextMessage(message, severityClass, !runningShowStatuses);
                    $statusWrapElem.html(statusHtml);
                    this.changeGroupWrapClassTo($groupWrapElem, severityClass);
                    // $formField.get(0).setCustomValidity(message.getMessageString());

                    // now set the error code variable that is local to this function
                    if (severity == 'error') errorCode = message.getErrorCode();
                } else {
                    if ($formField.data('show-valid-message')) {
                        var dataStore = app.data;
                        var successMessage = this.validationManager.configuration.messages.successMessage();
                        var statusHtml = this.validationManager.templater.contextMessage(successMessage, 'success', !runningShowStatuses);
                        $statusWrapElem.html(statusHtml);
                        this.changeGroupWrapClassTo($groupWrapElem, 'success');
                    }
                    // $formField.get(0).setCustomValidity('');
                }

                // Now set the elements HTML error data attribute if we have an error code,
                // or clear it if we do not. If we do not, its because the field either passed validation,
                // or no error code for it was specified for this field-error combination the valiation constraints file.
                this.setErrorCode($formField, errorCode);
            };

            // Clears all validation messages from all controls that are within 'form'
            Presenter.prototype.clearStatuses = function () {
                var functionScope = this;
                this.validationManager.$formElem.find('input, textarea, select').each(function (k, elem) {
                    var $elem = $(elem);
                    functionScope.clearStatus($elem);
                });
            };

            // Clears validation message for specified form control.
            Presenter.prototype.clearStatus = function ($elem) {
                var $statusWrapElem = this.getStatusWrapElem($elem);
                var $groupWrapElem = this.getGroupWrapElem($elem);
                this.clearGroupWrapContextualClass($groupWrapElem);
                $statusWrapElem.html('');
            };

            // If errorCode, set error code HTML attribute. If no error code, clear error code HTML data attribute.
            Presenter.prototype.setErrorCode = function ($elem, errorCode) {
                if ($elem.length) {
                    var $fileDropZone = $elem.closest('.file-drop-area');
                    var fileDropZone = null;
                    if ($fileDropZone.length) {
                        fileDropZone = $fileDropZone.get(0);
                    }
                    var elem = $elem.get(0);
                    if (errorCode) {
                        elem.dataset.errorCode = errorCode;
                        if (fileDropZone) fileDropZone.dataset.errorCode = errorCode;
                    } else {
                        delete elem.dataset.errorCode;
                        $elem.removeAttr('data-error-code');
                        if (fileDropZone) {
                            delete fileDropZone.dataset.errorCode;
                            $fileDropZone.removeAttr('data-error-code');
                        }
                    }
                }
            };

            Presenter._initd = true;
        }
    };

    function Validator(validationManager) {
        var scope = this;
        this.validationManager = validationManager;
        if (typeof Validator._initd === 'undefined') {

            // All validation messages should return true for a constraint pass, or false for a constraint fail.

            Validator.prototype.testRegularExpression = function (value, constraint) {
                return constraint.getParams().regularExpression.test(value);
            };

            Validator.prototype.testEmail = function (value, constraint) {
                return this.validationManager.configuration.emailPattern.test(value);
            };

            Validator.prototype.testUrl = function (value, constraint) {
                return this.validationManager.configuration.urlPattern.test(value);
            };

            Validator.prototype.testDate = function (value, constraint) {
                return this.validationManager.configuration.datePattern.test(value);
            };

            Validator.prototype.testStrongPassword = function (value, constraint) {
                return this.validationManager.configuration.strongPasswordPattern.test(value);
            };

            Validator.prototype.testPresent = function (value, constraint) {
                var $formField = constraint.getFormField();
                var formFieldType = constraint.getFormFieldType($formField);
                if (formFieldType == 'checkbox' || formFieldType == 'radio') {
                    return $formField.is(':checked');
                } else {
                    return !!value;
                }
            };

            Validator.prototype.testInArray = function (value, constraint) {
                return helpers.inArray(value, constraint.getParams().allowedValues);
            };

            Validator.prototype.testNotInArray = function (value, constraint) {
                return !helpers.inArray(value, constraint.getParams().disallowedValues);
            };

            Validator.prototype.testNumeric = function (value, constraint) {
                return !isNaN(value);
            };

            Validator.prototype.testOnlyDigits = function (value, constraint) {
                return /^\d+$/.test(value);
            };

            Validator.prototype.testMinLength = function (value, constraint) {
                return value.length >= constraint.getParams().size;
            };

            Validator.prototype.testMaxLength = function (value, constraint) {
                return value.length <= constraint.getParams().size;
            };

            Validator.prototype.testMinNumber = function (value, constraint) {
                return this.testOnlyDigits(value) && (value >= constraint.getParams().size);
            };

            Validator.prototype.testMaxNumber = function (value, constraint) {
                return this.testOnlyDigits(value) && (value <= constraint.getParams().size);
            };

            Validator.prototype.testMinItems = function (value, constraint) {
                return value.length >= constraint.getParams().size;
            };

            Validator.prototype.testMaxItems = function (value, constraint) {
                return value.length <= constraint.getParams().size;
            };

            Validator.prototype.testConfirmed = function (value, constraint) {
                var comparatorFieldId = constraint.getParams().comparatorFieldId;
                var $comparatorField = this.validationManager.configuration.getFormField(comparatorFieldId);
                var comparatorFieldValue = this.validationManager.configuration.getFormFieldValue($comparatorField);
                return value == comparatorFieldValue;
            };

            Validator.prototype.testMinFiles = function (value, constraint) {
                var $formField = constraint.getFormField();
                var files = this.validationManager.configuration.getFiles($formField);
                if (files) {
                    return files.length >= constraint.getParams().size;
                }
            };

            Validator.prototype.testMaxFiles = function (value, constraint) {
                var $formField = constraint.getFormField();
                var files = this.validationManager.configuration.getFiles($formField);
                if (files) {
                    return files.length <= constraint.getParams().size;
                }
            };

            Validator.prototype.testMinFileSize = function (value, constraint) {
                if (!value) return true;
                var $formField = constraint.getFormField();
                var files = this.validationManager.configuration.getFiles($formField);
                if (files) {
                    var totalFileSize = this.validationManager.configuration.getSizeOfFiles(files);
                    var minAllowedSize = constraint.getParams().size * 1024 * 1024;
                    return totalFileSize >= minAllowedSize;
                }
            };

            Validator.prototype.testMaxFileSize = function (value, constraint) {
                if (!value) return true;
                var $formField = constraint.getFormField();
                var files = this.validationManager.configuration.getFiles($formField);
                if (files) {
                    var totalFileSize = this.validationManager.configuration.getSizeOfFiles(files);
                    var maxAllowedSize = constraint.getParams().size * 1024 * 1024;
                    return totalFileSize <= maxAllowedSize;
                }
            };

            Validator.prototype.testFileType = function (value, constraint) {
                if (!value) return true;
                var $formField = constraint.getFormField();
                var validExtensions = constraint.getParams().validExtensions;
                var files = this.validationManager.configuration.getFiles($formField);
                if (files) {
                    var passed = true;
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        var ext = file.name.split('.').pop().toLowerCase();
                        if ($.inArray(ext, validExtensions) === -1) {
                            passed = false;
                        }
                    }
                    return passed;
                }
            };

            Validator._initd = true;
        }

    };

    return {
        build: function (validatorComponents, $formElem) {
            var validationManager = new ValidationManager(validatorComponents, $formElem);
            return validationManager;
        },
        ValidationManager: ValidationManager,
        Configuration: Configuration,
        ConstraintBag: ConstraintBag,
        Constraint: Constraint,
        MessageBag: MessageBag,
        Message: Message,
        Templater: Templater,
        Presenter: Presenter,
        Validator: Validator
    }
});
